module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon",
    style: ({
      color: _vm.color
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c61d8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Icon.vue
// module id = 707
// module chunks = 64